import { MenuItemsType, EarnFillIcon, EarnIcon } from '@pancakeswap/uikit'
import { ContextApi } from '@pancakeswap/localization'
import { DropdownMenuItems } from '@pancakeswap/uikit/src/components/DropdownMenu/types'
import { SUPPORT_GAMES_TEST } from 'config/constants/supportChains'

export type ConfigMenuDropDownItemsType = DropdownMenuItems & { hideSubNav?: boolean }
export type ConfigMenuItemsType = Omit<MenuItemsType, 'items'> & { hideSubNav?: boolean; image?: string } & {
  items?: ConfigMenuDropDownItemsType[]
}

const addMenuItemSupported = (item, chainId) => {
  if (!chainId || !item.supportChainIds) {
    return item
  }
  if (item.supportChainIds?.includes(chainId)) {
    return item
  }
  return {
    ...item,
    disabled: true,
  }
}

const config: (
  t: ContextApi['t'],
  isDark: boolean,
  languageCode?: string,
  chainId?: number,
) => ConfigMenuItemsType[] = (t, isDark, languageCode, chainId) =>
  [
    {
      label: t('Daily Action Games'),
      href: '/games',
      icon: EarnIcon,
      fillIcon: EarnFillIcon,
      image: '/images/decorations/pe2.png',
      items: [
        {
          label: t('All Games'),
          href: '/games',
          supportChainIds: SUPPORT_GAMES_TEST,
        },
        {
          label: t('My Created Games'),
          href: '/games/my-games',
          supportChainIds: SUPPORT_GAMES_TEST,
        },
      ].map((item) => addMenuItemSupported(item, chainId)),
    },
    {
      label: t('Classic Giveaway Contests'),
      disabled: true,
      href: '/giveaways',
      icon: EarnIcon,
      fillIcon: EarnFillIcon,
      image: '/images/decorations/pe2.png',
      items: [
        {
          label: t('All Giveaways'),
          disabled: true,
          href: '/giveaways',
          supportChainIds: SUPPORT_GAMES_TEST,
        },
        {
          label: t('My Created Giveaways'),
          disabled: true,
          href: '/giveaways/my-giveaways',
          supportChainIds: SUPPORT_GAMES_TEST,
        },
      ].map((item) => addMenuItemSupported(item, chainId)),
    },
  ].map((item) => addMenuItemSupported(item, chainId))

export default config
